import { ComponentRef, EventEmitter, inject, Injectable, signal, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { HalApiCaller } from '@dxc-technology/halstack-client';
import { environment } from 'src/environments/environment';
import { DialogProps } from '../shared/components/dialogs/custom-dialog/custom-dialog.component';
// import { DialogMessageComponent } from '../shared/dialog-message/dialog-message.component';
import { HttpClient } from '@angular/common/http';
import { Option } from '@dxc-technology/halstack-angular';
import { TranslateService } from '@ngx-translate/core';
import { DynamicComponentDirective } from '@shared/directives/dynamic-component.directive';
import { RequestProps } from '@shared/interface/common.interface';
import { AbstractHttpObservable } from '@shared/types/abstract';
import { HttpMethod } from '@shared/types/hal-client';
import { jwtDecode } from 'jwt-decode';
import _, { merge, pickBy } from 'lodash';
import * as pako from 'pako';
import { BehaviorSubject, defer, from, Observable, Subject } from 'rxjs';
import { METHOD } from '../shared/components/base-classes/base-group/constants';
import { CustomDialogComponent } from '../shared/components/dialogs/custom-dialog/custom-dialog.component';
import { Title } from '@angular/platform-browser';
import { DialogMessageComponent } from '../shared/components/dialogs/dialog-message/dialog-message.component';

@Injectable({
  providedIn: 'root',
})
export class CommonService implements AbstractHttpObservable {
  private readonly dialog = inject(MatDialog);
  private readonly http = inject(HttpClient);
  private readonly translate = inject(TranslateService);
  private readonly route = inject(ActivatedRoute);
  private readonly title = inject(Title);

  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  rolesChange: EventEmitter<any> = new EventEmitter();
  navigateWizard: EventEmitter<number> = new EventEmitter<number>();
  setHeader = new EventEmitter<any>();
  getTranslateValue = new EventEmitter<any>();
  currentLang = signal(this.translate.defaultLang);
  isValidation: EventEmitter<any> = new EventEmitter();
  summaryNavigateTab: number = 0;
  Active_Profile = environment.ENV_ACTIVE_PROFILE;
  ON_PREMISES = environment.ON_PREMISES;
  ON_PREMISES_CAS = environment.ON_PREMISES_CAS;
  ON_CLOUD = environment.ON_CLOUD;
  PROFILE = environment.ENV_ACTIVE_PROFILE;
  modifyRegistration = signal(false);
  header: any;
  routingLink: any;
  tokenInfo: any;
  userInfo: any;
  userName: any;
  userData: any;
  userId: any;
  persona: any;
  envUrl: any;
  clientNo: any;
  language: any;
  country: any;
  prodctBrochres: any = {};
  enpoint: string = '';
  previousData: any = {};
  isLoading = false;
  isDisabledUW$ = new BehaviorSubject<boolean>(true);
  allConfigDropdownList: any;
  provinceList = signal<Option[]>([]);
  intialDropdownModel: { [unit: string]: any } = {
    params: 'language_Setup',
  };
  dynamicComponents: DynamicComponentDirective;
  componentRef: ComponentRef<any>;
  private readonly languageChange$ = new Subject<any>();
  public languageVariable$ = this.languageChange$.asObservable();

  private readonly triggerlangChange = new Subject<any>();
  public triggerlangChange$ = this.triggerlangChange.asObservable();

  private readonly passDisclaimerData = new Subject<any>();
  public passDisclaimerData$ = this.passDisclaimerData.asObservable();
  groupNameList = signal<Option[]>([]);

  setDisclaimerData(newValue: any): void {
    this.passDisclaimerData.next(newValue);
  }

  setTriggerlangChange(newValue: any): void {
    this.triggerlangChange.next(newValue);
  }

  setlanguageChange(newValue: any): void {
    this.languageChange$.next(newValue);
  }

  constructor() {
    this.initModuleSerivce();
    // this.getCognitoLogin();
  }

  //get Navigation URL
  async getNavigationUrl(userName, lobView, personaView) {
    let res = await HalApiCaller.get({
      url: environment.API_COMMON_USERROLE_SERVER_URL + userName + '/userProfile/lookup?lookupName=envUrl&lob=' + lobView + '&persona=' + personaView,
      headers: this.getHeaders(),
    });
    this.envUrl = res.body;
    return this.envUrl;
  }

  async getAllConfigDropdown(token?: string) {
    try {
      const listOption = this.intialDropdownModel['params'];
      const headers = token
        ? {
            Authorization: 'Bearer ' + token,
            'x-api-key': environment.COGNITO.x_api_key,
            ...(environment.ON_CUSTOMIDP === this.PROFILE ? { 'X-Referer': 'GroupSales' } : {}),
          }
        : this.getHeaders();
      const response = await HalApiCaller.get({
        headers,
        url: environment.API_GROUPCONFIGURATION_SERVER_URL + `/lookup?list=${listOption}`,
      });
      if (_.isEmpty(response?.body?.language_Setup)) {
        response.body.language_Setup = _.get(response, 'body.language', []);
      }
      this.allConfigDropdownList = response.body;
    } catch (err: any) {
      return err.response?.data;
    }
  }

  setLoading(isLoading: boolean) {
    setTimeout(() => (this.isLoading = isLoading));
  }
  setTimeout(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async setTimeoutLoading(ms: number = 500) {
    this.setLoading(true);
    await this.setTimeout(ms);
    this.setLoading(false);
  }

  //Cognito Login
  async getCognitoLogin() {
    try {
      let headers = {
        'Content-Type': 'application/x-amz-json-1.1',
        'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth',
        'X-Amz-User-Agent': 'aws-amplify/0.1.x js',
      };
      let body = {
        AuthFlow: 'USER_PASSWORD_AUTH',
        AuthParameters: { USERNAME: environment.userName, PASSWORD: environment.password },
        ClientId: environment.COGNITO.ClientId,
        ClientMetadata: {},
      };
      let url = 'https://cognito-idp.ap-southeast-1.amazonaws.com';
      let tokenInfo = await this.http
        .post<any>(url, body, { headers })
        .toPromise()
        .then(
          (data) => {
            return data;
          },
          (error) => {
            return { error: error };
          }
        );
      if (!tokenInfo || (tokenInfo && tokenInfo.hasOwnProperty('error')) || tokenInfo.hasOwnProperty('errors')) {
        localStorage.setItem('accessToken', '');
        return '';
      } else {
        let token = tokenInfo.AuthenticationResult.IdToken;
        localStorage.setItem('access_token', token);
        sessionStorage.setItem('access_token', token);
        sessionStorage.setItem('userToken', token);
        this.header = this.getHeaders();
        // Emit header for all service
        this.setHeader.emit(this.header);
        this.getAllConfigDropdown();
        return tokenInfo;
      }
    } catch (err) {}
  }

  DownloadList: Array<any> = [
    {
      value: '1',
      label: 'Download Receipt',
      image: `${this.RESOURCE_SERVER_URL}/assets/images/Policy_Details/Member_Details/Download.svg`,
    },
    {
      value: '2',
      label: 'Follow Ups',
      image: `${this.RESOURCE_SERVER_URL}/assets/images/Policy_Details/Member_Details/Follow_ups.svg`,
    },
  ];

  initModuleSerivce() {
    this.header = this.getHeaders();
    this.updateUser();
  }

  updateUser() {
    this.userId = localStorage.getItem('userName');
    this.persona =
      environment.ENV_ACTIVE_PROFILE === environment.ON_CUSTOMIDP
        ? localStorage.getItem('selected_role') || sessionStorage.getItem('selected_role')
        : sessionStorage.getItem('selected_role');
    this.clientNo = localStorage.getItem('clientNumber');
    this.language = localStorage.getItem('language');
    this.country = localStorage.getItem('country');
  }
  getHeaderPersonal() {
    this.updateUser();
    this.header = this.getHeaders();
    if (this.clientNo != null && this.clientNo) {
      return {
        ...this.header,
        username: this.userId,
        persona: this.persona,
        clientnumber: this.clientNo,
        language: this.language ? this.language : environment.language,
        country: this.country ? this.country : 'IDN',
      };
    } else {
      this.language = localStorage.getItem('language');
      return {
        ...this.header,
        username: this.userId,
        persona: this.persona,
        language: this.language ? this.language : environment.language,
        country: this.country ? this.country : 'IDN',
      };
    }
  }
  // Get All Dropdown For Policy
  async getDropDownList(listOption: any, changeUrl: boolean = false) {
    try {
      let response = await HalApiCaller.get({
        headers: this.getHeaderPersonal(),
        url: changeUrl
          ? environment.API_CONFIGURATION_SERVER_URL + '/lookup?list=' + listOption
          : environment.API_GROUPCONFIGURATION_SERVER_URL + '/lookup?list=' + listOption,
      });
      return response;
    } catch (err: any) {
      return err.response.data;
    }
  }

  // Get Maximum file size allowed to be uploaded
  async getMaxFileSizeAllowed(moduleName: any, resMaxSize: any) {
    try {
      let result = {
        maxFileSize: '',
        validType: '',
        maxSizeByte: 5242880,
      }; // More information if needed
      result.maxFileSize = resMaxSize?.body?.UploadFileSize.find((p) => p.value === moduleName)?.MAXFILSIZ;
      result.validType = resMaxSize?.body?.UploadFileSize.find((p) => p.value === moduleName)?.VALDTYPE;
      if (result.maxFileSize.slice(-2) == 'MB') {
        result.maxSizeByte = parseInt(result.maxFileSize.slice(0, -3)) * 1024 * 1024;
      }
      return result;
    } catch (err: any) {
      return err.response.data;
    }
  }

  checkFutureDate(date: any) {
    let year, month, day;
    if (date.length == 10) {
      year = date.substring(6, 10);
      month = date.substring(3, 5);
      day = date.substring(0, 2);
    } else if (date.length == 8) {
      year = date.substring(4, 8);
      month = date.substring(2, 4);
      day = date.substring(0, 2);
    }
    let today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    let compDate = new Date(year, month - 1, day); // month - 1 because January == 0
    let diff = today.getTime() - compDate.getTime();
    if (diff < 0) {
      return true;
    }
    return false;
  }

  // Get All Group Dropdown For Policy
  async getGroupDropDownList(userId: any, listOption: any) {
    try {
      // let response = await HalApiCaller.get({
      //   headers: this.getHeaderPersonal(),
      //   url:
      //     environment.API_GROUPCONFIGURATION_SERVER_URL +
      //     '/lookup?list=' +
      //     listOption,
      // });
      // return response;

      return this.http.get(environment.API_GROUPCONFIGURATION_SERVER_URL + '/lookup?list=' + listOption);
    } catch (err: any) {
      return err.response.data;
    }
  }

  // Check Label of Dropdown with value of dropdown
  getLabelOfDropdown(valueOfDropdown: any, dropDownName: any) {
    let label;
    for (let e of dropDownName) {
      if (e.value == valueOfDropdown) {
        label = e.label;
        break;
      } else {
        label = '';
      }
    }
    return label;
  }

  // async getDocumentDMS(IdDocument: any) {
  //   try {
  //     // let response = await HalApiCaller.get({
  //     //   headers: this.getHeaderPersonal(),
  //     //   url: environment.API_DMS_SERVER_URL + `/${IdDocument}`,
  //     // });
  //     // return response;

  //     return this.http.get(environment.API_DMS_SERVER_URL + `/${IdDocument}`);
  //   } catch (error) {
  //
  //   }
  // }

  // Get content base64 PDF
  async getDocumentPdf(userId: any, data: any, templateName: any, lang: any) {
    try {
      // let response = await HalApiCaller.post({
      //   headers: this.getHeaderPersonal(),
      //   url:
      //     environment.API_PRINTS_SERVER_URL +
      //     '/v2?templateName=' +
      //     templateName +
      //     '&lang=' +
      //     lang,
      //   body: data,
      // });
      // return response;

      return this.http.get(environment.API_PRINTS_SERVER_URL + '/v2?templateName=' + templateName + '&lang=' + lang);
    } catch (err: any) {
      return err.response.data;
    }
  }
  // For download  File
  base64ToArrayBuffer(base64: any) {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  async downloadFile(base64: any, typeFile: any, fileName: any, isZip?: any) {
    let arrayBuffer = await this.base64ToArrayBuffer(base64);
    if (isZip) {
      arrayBuffer = pako.ungzip(arrayBuffer);
    }
    const csvFile = new Blob([arrayBuffer], {
      type: this.resolveDownloadMimeType(typeFile, fileName),
    });
    const csvUrl = URL.createObjectURL(csvFile);
    let anchor = document.createElement('a');
    anchor.href = csvUrl;
    anchor.download = fileName;
    // iOS Safari ignores the download attribute on blob URLs and names the saved file after the page title
    const pageTitle = this.title.getTitle();
    this.title.setTitle(fileName);
    anchor.click();
    setTimeout(() => {
      this.title.setTitle(pageTitle);
      URL.revokeObjectURL(csvUrl);
    }, 1000);
  }

  private resolveDownloadMimeType(typeFile: any, fileName: any): string {
    const mimeByExtension: Record<string, string> = {
      pdf: 'application/pdf',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      xls: 'application/vnd.ms-excel',
      csv: 'text/csv',
      zip: 'application/zip',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      doc: 'application/msword',
    };
    const fileExtension = String(fileName ?? '').split('.').pop()?.toLowerCase() ?? '';
    return mimeByExtension[fileExtension] || typeFile;
  }

  async shareDocViaEmail(userId: any, linkURL: any, body: any) {
    // let data = await HalApiCaller.post({
    //   headers: this.getHeaderPersonal(),
    //   url: linkURL,
    //   body,
    // });
    // return data;

    return this.http.post(linkURL, body);
  }

  async callGroupDropDown(userId: any, link: any) {
    // let data = await HalApiCaller.get({
    //   headers: this.getHeaderPersonal(),
    //   url: environment.API_GROUPCONFIGURATION_SERVER_URL + '/' + link,
    // });
    // return data;

    return this.http.get(environment.API_GROUPCONFIGURATION_SERVER_URL + '/' + link);
  }

  async getProfileUser(userId: any) {
    let data = await HalApiCaller.get({
      headers: this.getHeaderPersonal(),
      url: environment.API_COMMON_USERROLE_SERVER_URL + `/${userId}/userProfile/lookup?lookupName=persona&&lob=N`,
    });
    return data;
  }

  async getLOBdropdown(userId: any) {
    let data = await HalApiCaller.get({
      headers: this.getHeaderPersonal(),
      url: environment.API_COMMON_USERROLE_SERVER_URL + `/${userId}/userProfile/lookup?lookupName=lob`,
    });
    return data;
  }

  getHeaders() {
    let headers;
    headers = {
      Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      'x-api-key': environment.COGNITO.x_api_key,
    };
    if (environment.ON_CUSTOMIDP === this.PROFILE) {
      headers['X-Referer'] = 'GroupSales';
    }
    return headers;
  }

  private isAgentUser(): boolean {
    const tokenIss = localStorage.getItem('token_iss') || sessionStorage.getItem('token_iss');
    return tokenIss === 'agent';
  }

  private isCustomIDPProfile(): boolean {
    return environment.ENV_ACTIVE_PROFILE === 'customIDP';
  }

  private async getGroupSalesUserProfileDetail(userName: any) {
    const persona = sessionStorage.getItem('selected_role');
    const clientnumber = localStorage.getItem('clientNumber');
    const headers = this.getHeadersWithPROFILE();
    const data = await HalApiCaller.get({
      headers: { ...headers, username: userName, persona, clientnumber },
      url: environment.API_COMMON_USERROLE_SERVER_URL + '/groupProfileDetailsForUserById?groupId=SalesForce',
    });
    return data.body;
  }

  async getDetailUserName(userName: any) {
    const isCustomIDPAgent = this.isCustomIDPProfile() && this.isAgentUser();

    if (isCustomIDPAgent) {
      try {
        return await this.getGroupSalesUserProfileDetail(userName);
      } catch (error) {
        console.warn('Agent profile fetch failed, trying fallback');
      }
    }

    const data = await HalApiCaller.get({
      headers: this.getHeaderPersonal(),
      url: environment.API_COMMON_USERROLE_SERVER_URL + `/userdata/${userName}/getUserProfile?list=userInfo,roles`,
    });
    return data.body;
  }

  async getActiveProfileUser(userName: any) {
    let data = await HalApiCaller.get({
      headers: this.getHeaderPersonal(),
      url: environment.API_COMMON_USERROLE_SERVER_URL + `/${userName}/userProfile/active?lob=N`,
    });
    return data.body;
  }

  //get Token and  Token_Info
  get_tokenInfo() {
    if (this.Active_Profile == this.ON_PREMISES) {
      var token = sessionStorage.getItem('id_token') || '';
      this.tokenInfo = jwtDecode(token);
      localStorage.setItem('access_token', token);
      localStorage.setItem('userName', this.tokenInfo.preferred_username);
      localStorage.setItem('clientNumber', this.tokenInfo.clientNumber); //check
      localStorage.setItem('firstName', this.tokenInfo.firstName);
      localStorage.setItem('lastName', this.tokenInfo.lastName);
    }
    // Congito environment
    else if (this.Active_Profile == this.ON_CLOUD) {
      var token = localStorage.getItem('id_token') || '';
      this.tokenInfo = jwtDecode(token);
      localStorage.setItem('userName', this.tokenInfo['email']);
    }
    // CAS environment
    else if (this.Active_Profile == this.ON_PREMISES_CAS) {
      var token = localStorage.getItem('access_token') || '';

      this.tokenInfo = jwtDecode(token);
    }
    return this.tokenInfo;
  }
  //get user info
  async getUserInfo(userId: any) {
    this.userName = localStorage.getItem('userName');
    // let res = await HalApiCaller.get({
    //   url:
    //     environment.API_USERINFO_SERVER_URL + `?userName=${this.userName}`,
    //   headers: this.getHeaderPersonal(),
    // });
    // this.userInfo = res;
    // localStorage.setItem('clientNumber', this.userInfo.body.clientNumber);//check
    // return this.userInfo;

    return this.http.get(environment.API_USERINFO_SERVER_URL + `?userName=${this.userName}`);
  }
  getCurrentURL() {
    let snapshot: any = this.route.snapshot;
    return snapshot?._routerState?.url || '';
  }
  async getUserRoles() {}

  showNotifyMessage(message: any, status: any, navigateTo?: any, buttonName?: any) {
    if (message != undefined) {
      let colorBG;
      let colorText;
      let icon;
      if (status == 'success') {
        status = 'success';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'uploadSuccess') {
        status = 'uploadSuccess';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'error') {
        status = 'error';
        colorBG = { background: '#dc3545', height: '3rem' };
        colorText = { color: '#dc3545', height: '3rem' };
        icon = 'error';
      } else if (status == 'creationSuccess') {
        status = 'PersonalCreation';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'confirmStatus') {
        status = 'confirmStatus';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'confirmStatus';
      } else if (status == 'billConfirmation') {
        status = 'billConfirmation';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'billingError') {
        status = 'billingError';
        colorBG = { background: '#dc3545', height: '3rem' };
        colorText = { color: '#dc3545', height: '3rem' };
        icon = 'error';
      } else if (status == 'submission') {
        status = 'submission';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'submission';
      } else if (status == 'shareSuccess') {
        status = 'ShareEmail';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'sendMessageSuccess') {
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'fileUploadSuccess') {
        status = 'uploadSuccess';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'modifyClaimMessageSuccess') {
        status = 'modifyClaimSuccess';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'createClaimMessageSuccess') {
        status = 'createClaimSuccess';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'createSuccess') {
        status = 'createSuccess';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'claimCreationMessageSuccess') {
        status = 'claimCreationSuccess';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'tpaSuccess') {
        status = 'tpaSuccess';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'claimDetailsSuccessfullMessage') {
        status = 'claimDetailsSuccessfull';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'providerOrgCreationSuccess') {
        status = 'providerOrgCreateSuccess';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'providerOrgCreationFail') {
        status = 'providerOrgCreateFail';
        colorBG = { background: '#dc3545', height: '3rem' };
        colorText = { color: '#dc3545', height: '3rem' };
        icon = 'success';
      } else if (status == 'providerLinkCreationSuccess') {
        status = 'providerLinkCreationSuccess';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'providerOrgCreaModSuccess') {
        status = 'providerOrgCreaModSuccess';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'drugSuccess') {
        status = 'drugMediacalSuccess';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'feeScheduleAddSuccessMessage') {
        status = 'feeScheduleAddSuccessfully';
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      } else if (status == 'submitSuccess') {
        colorBG = { background: '#5f249f', height: '3rem', padding: '10px' };
        colorText = { color: '#ffffff', height: '3rem' };
        icon = 'success';
      }

      const dialog = this.dialog.open(DialogMessageComponent, {
        disableClose: true,
        data: {
          message: message,
          status: status,
          colorBG: colorBG,
          colorText: colorText,
          icon: icon,
          buttonName: buttonName,
          navigateTo: navigateTo,
        },
        width: '350px',
        position: {
          top: '17%',
          left: '40%',
        },
        minHeight: '180px',
      });
      return dialog;
    }
    return null;
  }
  hasValueNotEmpty(variable: any) {
    return typeof variable !== 'undefined' && variable !== null && variable.length !== 0;
  }
  Transaction = [
    {
      id: 1,
      billNumber: '633515',
      issueDate: '01/01/2022',
      transactionDescription: 'New Business',
    },
  ];
  postSummary = [
    {
      id: 1,
      productType: 'GTL1',
      plan: '001',
      postedPremium: '180',
      extraPremium: '',
    },
    {
      id: 2,
      productType: 'GTL1',
      plan: '002',
      postedPremium: '60',
      extraPremium: '',
    },
  ];

  Summary = [
    {
      item: 'Gross Premium Less',
      amount: '162',
    },
    {
      item: 'Administration Fee',
      amount: '',
    },
    {
      item: 'GST (Service Tax)',
      amount: '9.72',
    },
    {
      item: 'Stamp Duty',
      amount: '1.00',
    },
    {
      item: 'Gross Amount',
      amount: '172.72',
    },
    {
      item: 'Commission1',
      amount: '4.86',
    },
    {
      item: 'Commission2',
      amount: '',
    },
    {
      item: 'Net Amount',
      amount: '167.86',
    },
    {
      item: 'PPMC Cost',
      amount: '',
    },
  ];

  callApi({ method = METHOD.GET, url = this.enpoint, body, headers = {} }: RequestProps): Observable<any> {
    let mergedHeaders = merge(this.getHeaderPersonal(), headers);
    if (method === METHOD.DELETE) {
      const deleteSecurity = {
        'X-Requested-From': 'Web-UI',
        'X-Action-Type': 'Hard-Delete-From-UI',
      };
      mergedHeaders = merge(mergedHeaders, deleteSecurity);
    }

    const customHeaders = pickBy(mergedHeaders, (item) => !!item);

    if (method === METHOD.GET) {
      return this.http[method](url, {
        headers: customHeaders,
        params: body,
      });
    }
    if (method === METHOD.DELETE) {
      return this.http[method](url, {
        headers: customHeaders,
      });
    }
    return this.http[method](url, body || {}, {
      headers: customHeaders,
    });
  }

  //Method GET
  async commonGet(url: any, headers = {}) {
    try {
      let response = await HalApiCaller.get({
        url: url,
        headers: { ...this.getHeaderPersonal(), ...headers },
      });
      return response;
    } catch (err: any) {
      return err.response;
    }
  }

  //Method POST
  async commonPost(url: any, body: any = {}, headers = {}) {
    try {
      let response = await HalApiCaller.post({
        url: url,
        body,
        headers: { ...this.getHeaderPersonal(), ...headers },
      });
      return response;
    } catch (err: any) {
      return err.response;
    }
  }

  //Method DELETE
  async commonDelete(url: any) {
    try {
      let response = await HalApiCaller.del({
        url: url,
        headers: this.getHeaderPersonal(),
      });
      return response;
    } catch (err: any) {
      return err.response;
    }
  }

  //Method PATCH
  async commonPatch(url: any, body: any = {}) {
    try {
      let response = await HalApiCaller.patch({
        url: url,
        body,
        headers: this.getHeaderPersonal(),
      });
      return response;
    } catch (err: any) {
      return err.response;
    }
  }

  commonHttpObservable<T = any>(
    url: string,
    options: { headers?: Record<string, string>; method: HttpMethod; body?: Record<string, any> } = { method: 'get' }
  ): Observable<T> {
    return defer(() =>
      from(
        HalApiCaller[options.method]({
          url: url,
          headers: { ...this.getHeaderPersonal(), ...options.headers },
          body: _.get(options, 'body'),
        })
      )
    );
  }

  getHeadersWithPROFILE() {
    let headers;
    //On Premises
    if (this.ON_PREMISES === this.PROFILE) {
      headers = {
        authorization: 'Bearer ' + localStorage.getItem('access_token'),
      };
    }
    //Cloud
    else if (this.ON_CLOUD === this.PROFILE) {
      headers = {
        authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'x-api-key': environment.COGNITO.x_api_key,
      };
    }
    //CAS
    else if (this.PROFILE === this.ON_PREMISES_CAS) {
      headers = {
        authorization: 'Bearer ' + localStorage.getItem('access_token'),
      };
    }
    //customIDP
    else if (environment.ON_CUSTOMIDP === this.PROFILE) {
      headers = {
        authorization: 'Bearer ' + localStorage.getItem('access_token'),
        'X-Referer': 'GroupSales',
      };
    }
    this.header = headers;
    return headers;
  }

  isHeadersWithPROFILE() {
    let isOk = true;
    //On Premises
    if (this.ON_PREMISES === this.PROFILE) {
    }
    //Cloud
    else if (this.ON_CLOUD === this.PROFILE) {
      if (!localStorage.getItem('access_token')) {
        isOk = false;
      }
    }
    //CAS
    else if (this.PROFILE === this.ON_PREMISES_CAS) {
    }
    return isOk;
  }

  commonEmptyField(field, message) {
    let result = message;
    if (message == 'Mandatory field(s) (*) must not be empty.' || message == 'Kolom wajib (*) harus diisi') {
      result = `${field} ${this.translate.instant('label.common.cannotBeBlank')}`;
    }
    return result;
  }

  // Get Table Customization
  async getTableCustomization(userId, profileId, tableName) {
    try {
      //check
      let response = await HalApiCaller.get({
        url: environment.API_COMMON_USERROLE_SERVER_URL + '/users/' + userId + '/profiles/' + profileId + '/customization?tableName=' + tableName,
        headers: this.getHeaderPersonal(),
      });
      return response;
    } catch (err) {
      return err.response.data;
    }
  }

  // Add Table Customization
  async addCustomization(userId, profileId, tableName, body) {
    try {
      //check
      let response = await HalApiCaller.post({
        url: environment.API_COMMON_USERROLE_SERVER_URL + '/users/' + userId + '/profiles/' + profileId + '/customization?tableName=' + tableName,
        body,
        headers: this.getHeaderPersonal(),
      });
      return response;
    } catch (err) {
      return err.response.data;
    }
  }

  //Table Customization
  async tableCustomization(selectedFieldBody, tableName) {
    const isCustomIDPAgent = this.isCustomIDPProfile() && this.isAgentUser();

    if (isCustomIDPAgent) {
      return null;
    }

    try {
      let selectFields;
      let selectedUserId = localStorage.getItem('selectedUserId');
      let profileId = localStorage.getItem('profileId');

      if (selectedUserId == null) {
        let dataUser = await this.getDetailUserName(localStorage.getItem('userName'));
        selectedUserId = dataUser['userModelId'];
        let profileUser = await this.getActiveProfileUser(localStorage.getItem('userName'));
        profileId = profileUser.uuid;
        localStorage.setItem('selectedUserId', selectedUserId);
        localStorage.setItem('profileId', profileUser.uuid);
        localStorage.setItem('country', profileUser.country);
      }
      if (profileId == null) {
        let profileUser = await this.getActiveProfileUser(localStorage.getItem('userName'));
        profileId = profileUser['uuid'];
        localStorage.setItem('profileId', profileId);
        localStorage.setItem('country', profileUser.country);
      }
      if (!this.allConfigDropdownList?.language_Setup) {
        this.getAllConfigDropdown();
      }
      let data = await this.getTableCustomization(selectedUserId, profileId, tableName);
      if (data?.body?._links?._count == 0) {
        await this.addCustomization(selectedUserId, profileId, tableName, {
          selectedFields: selectedFieldBody,
        });
        let dataNew = await this.getTableCustomization(selectedUserId, profileId, tableName);
        selectFields = dataNew?.body?._links?.item;
      } else {
        selectFields = data?.body?._links?.item;
      }
      return selectFields;
    } catch (error) {
      console.error('Table customization error:', error);
      return null;
    }
  }

  /**
   * Show dialog base on custom dialog component.
   * @param data - Data passed to CustomDialogComponent
   * @param template - Template to show inside the dialog. E.g: ng-template
   * @param config - Optional Angular Material dialog config.
   * @returns MatDialogRef
   */
  showCustomDialog(data: DialogProps, template: TemplateRef<any>, config: MatDialogConfig<DialogProps> = {}) {
    const dialog = this.dialog.open(CustomDialogComponent, { ...config, data });
    dialog.componentInstance.tempDialog = template;
    return dialog;
  }

  setState<T>(key: string, value: T) {
    sessionStorage.setItem(key, value ? JSON.stringify(value) : '');
  }

  getState(key: string): any {
    return JSON.parse(sessionStorage.getItem(key) || '{}');
  }

  clearState() {
    sessionStorage.clear();
  }

  removeState(key: string) {
    sessionStorage.removeItem(key);
  }
  callApiForQsn({ method, url = this.enpoint, body, headers = {} }: RequestProps): Observable<any> {
    const customHeaders = { Authorization: 'Bearer ' + localStorage.getItem('access_token'), 'x-api-key': environment.COGNITO.x_api_key };

    if (method === METHOD.GET) {
      return this.http[method](url, {
        headers: customHeaders,
        params: body,
      });
    }
    if (method === METHOD.DELETE) {
      return this.http[method](url, {
        headers: customHeaders,
      });
    }
    return this.http[method](url, body, {
      headers: customHeaders,
    });
  }

  updateDisable(status: boolean) {
    this.isDisabledUW$.next(status);
  }

  getCurrentLang() {
    return this.translate.currentLang;
  }

  openDialogsInSequence(messages: string[]): void {
    this.openNextDialog(messages, 0);
  }

  openNextDialog(messages: any[], index: number): void {
    if (index < messages.length) {
      const dialogRef = this.showNotifyMessage(messages[index].message, 'error');

      dialogRef.afterClosed().subscribe(() => {
        this.openNextDialog(messages, index + 1);
      });
    }
  }

  setAppTitle(title: string) {
    this.title.setTitle(this.translate.instant(title));
  }

  async getAllGroupNames() {
    try {
      const url = `${environment.API_COMMON_USERROLE_SERVER_URL}/getAllGroupName`;
      const res = await this.commonGet(url);
      this.groupNameList.set(_.get(res, 'body', []));
      console.log('res getAllGroupNames: ', res);
    } catch (error) {
      console.error(error);
    }
  }
}

export function setLocalStorageItem(key: string, value: string): void {
  localStorage.setItem(key, value);
  const event = new CustomEvent('localStorageChanged', {
    detail: { key, newValue: value },
  });
  window.dispatchEvent(event);
}
